import { render } from "./SectionBlock.vue?vue&type=template&id=2bd0ce7f"
import script from "./SectionBlock.vue?vue&type=script&lang=js"
export * from "./SectionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__